import { PageHeader } from "antd";
import LayoutCss from "layout/layout.module.scss";
import { useDashboardFilters } from "./hooks/useDashboardFilters";
import { useArrowPositioning } from "./hooks/useArrowPositioning";
import { DashboardHeader } from "./dashboardHeader";
import { EmptyState } from "./components/emptyState/emptyState";
import styles from "./dashboard.module.scss";
import { DashboardContainer } from "./dashboardContainer";

export default function Dashboard() {
  const {
    client,
    recruiter,
    isTeamView,
    fetchRecruiters,
    handleClientChange,
    handleRecruiterChange,
    showEmptyState,
  } = useDashboardFilters();

  const { selectorsRef, emptyStateRef } = useArrowPositioning(showEmptyState);

  return (
    <>
      <PageHeader
        className={`${styles.sitePageHeader} ${LayoutCss.appPageHeader}`}
        title="Recruiter Dashboard"
        extra={
          <DashboardHeader
            client={client}
            recruiter={recruiter}
            isTeamView={isTeamView}
            fetchRecruiters={fetchRecruiters}
            onClientChange={handleClientChange}
            onRecruiterChange={handleRecruiterChange}
            selectorsRef={selectorsRef}
          />
        }
      />
      {showEmptyState ? (
        <EmptyState isTeamView={isTeamView} emptyStateRef={emptyStateRef} />
      ) : (
        <DashboardContainer
          clientId={client.value}
          recruiterId={recruiter.value}
        />
      )}
    </>
  );
}
